var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menu && _vm.menuItems)?_c('div',[(_vm.$vuetify.breakpoint.xsOnly)?_c('XsMenu',{attrs:{"menu":_vm.menu,"menuItems":_vm.menuItems}}):_c('Menu',{attrs:{"menu":_vm.menu,"menuItems":_vm.menuItems}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }